import React from "react";
import { View, StyleSheet } from "react-native";
import Text from "@components/ds/DsText";
import GreenTick from "@assets/svg/GreenTick";
import Pill from "@components/ds/Pill";
import { getShipmentRowStatus } from "../helpers";
import { tokens } from "@components/ds/tokens";

// One row on the "SHIPMENTS ON THIS TP" roster:
// ✅ RACKED (with rack no) / ◯ SCAN NOW (the next pending one) / ⬚ PENDING
//
// The status is a pill (spec p2 frame 4's "roster rows with ✅ / SCAN NOW
// / PENDING pills"), reusing the same Chip as the TP list's status badge.
// Words are literal English caps, same convention as that chip (see
// helpers.js getTpChip) — the mock shows them that way regardless of app
// language.

const STATUS_TONE = {
  RACKED: "racked",
  SCAN_NOW: "toRack",
  PENDING: "disabled",
};

const ShipmentRosterRow = ({ shipment, nextPendingId }) => {
  const status = getShipmentRowStatus(shipment, nextPendingId);
  const label =
    status === "RACKED"
      ? shipment.rack?.rack_no || "RACKED"
      : status === "SCAN_NOW"
        ? "SCAN NOW"
        : "PENDING";

  return (
    <View
      testID={`receiving-roster-row-${shipment.shipment_id}`}
      style={styles.row}
    >
      <View style={styles.left}>
        {status === "RACKED" ? (
          <GreenTick />
        ) : (
          <View
            style={[
              styles.marker,
              status === "SCAN_NOW" && styles.markerActive,
            ]}
          />
        )}
        <Text variant="body_text_4" style={styles.id}>
          {shipment.shipment_id}
        </Text>
      </View>
      <Pill
        label={label}
        tone={STATUS_TONE[status]}
        testID={`receiving-roster-status-${shipment.shipment_id}`}
      />
    </View>
  );
};

export default ShipmentRosterRow;

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingVertical: tokens.spacing.small + 2,
    paddingHorizontal: tokens.spacing.large,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: tokens.borderLight,
    backgroundColor: tokens.surface,
  },
  left: { flexDirection: "row", alignItems: "center", flex: 1 },
  marker: {
    width: 16,
    height: 16,
    borderRadius: 8,
    borderWidth: 1.5,
    borderColor: tokens.borderMedium,
    marginRight: tokens.spacing.small,
  },
  markerActive: { borderColor: tokens.primary },
  id: { color: tokens.textPrimary, marginLeft: tokens.spacing.small },
});
